import React, { Component } from 'react';
import '../../inc/genstyle.css';
import IHeader from './ifragmentheader';
import ISidemenu from './ifragmentsidemenu';
import DescriptionIcon from '@mui/icons-material/Description';
import Popup from '../../inc/popup';
import '../../inc/popup.css';
import ISendNotifDetail from './inotificationsend-detail';

const authKey = global.config.authBearerKey+"##"+global.config.kindcode[1];
 
class ISendNotification extends Component {
  constructor(props) {
    super(props);
    this.state = {
        stTitle: '',
        pageShow: '10',
        keyword: '',
        styleTb: 'table',
        data: [],
        data_all: [],
        cath_list: [],
        isOpen: false,
        otherContent: '',
        domainname: '',
        notif_type: 1,
        notif_cath: ""
    };
    this.loadData = this.loadData.bind(this);
  }
  togglePopClose() {
    this.setState( prevState => {
      return {  
          ...prevState.isOpen, isOpen: false,
      }
    })
  } 
  urlviewDetail(valId,content) {
    this.setState( prevState => {
      return {  
          ...prevState.isOpen, isOpen: true,
          ...prevState.otherContent, otherContent: content, 
        
      }
    })
  }
  handleSelect = (e) => {
    const value = e.target.value;
    const inputname = e.target.name;

    var setStatez = {};
    setStatez[inputname] = value;

    if(inputname === "notif_type") {
      this.loadData(value);
    } else if(inputname === "notif_cath") {
      var resultData = this.state.data_all;
      if(value !== "") {
        resultData = this.state.data_all.filter((list) =>  {
          return (list.licence_cath?.toLowerCase().includes(value.toLowerCase()));
        });  
      } 
      setStatez.data = resultData;
    }

    this.setState(setStatez);
  }
  loadData(ty) {
    document.getElementById('loading-area').style.display = 'block'; 
    fetch(global.config.urlLink+"/licencenotif/"+ty, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization': authKey,
        }
    }).then(response => {
        if(response.status === 200) {
            return response.json()
        } else {
            console.log('Something happened wrong');
        }
    }).then(resJson => {
        document.getElementById('loading-area').style.display = 'none'; 
        if(resJson.status === '200' && resJson.values.length > 0) { 
            var cathArr = [];
            if(resJson.values.length > 0) {
              resJson.values.forEach((items) => {
                if(items.licence_cath !== undefined) {
                  cathArr.includes(items.licence_cath.toLowerCase())
                  if(cathArr.includes(items.licence_cath) === false) { cathArr.push(items.licence_cath); }
                }
              })
            }
            var dataArrAsc = resJson.values.sort((a, b) => a.dateend_periode._seconds - b.dateend_periode._seconds);
            this.setState({
                styleTb: 'table table-striped',
                cath_list: cathArr,
                data: dataArrAsc,
                data_all: dataArrAsc
            })
        } else {
            this.setState({
                styleTb: 'table table-striped',
                cath_list: [],
                data: [],
                data_all: []
            })
        }
    }).catch(err => {
        document.getElementById('loading-area').style.display = 'none'; 
    });
  }
  componentDidMount() {
    this.loadData(this.state.notif_type);
  }

  contentTableList() {
    var clientList = [];
    if(this.state.data.length > 0) {
        for(var ls=0; ls < this.state.data.length; ls++) {
            var retResult = this.state.data[ls];
            clientList.push(<tr key={retResult.docid}>
                <th scope="row-field">{ls+1}</th>
                <td>{retResult.client_name}<br/><span className="font-sublist">{retResult.client_country}</span></td>
                <td>{retResult.domain_name}</td>
                <td>{retResult.licence_type}</td>
                <td>{retResult.licence_cath}</td>
                <td>{retResult.end_periode}</td>
                
                <td style={{width:'80px'}}>
                    {retResult.sendContent !== undefined? 
                    <DescriptionIcon className="iconGrey mgR20" onClick={this.urlviewDetail.bind(this, retResult.domain_name, JSON.stringify(retResult))}/>
                    : ''
                    }
                </td>
              </tr>)
        }
    } else {
        clientList.push(<tr key="1">
            <td colSpan="6" className="textCenter"><div className="mgT20 mgB20">:: no record ::</div></td>
          </tr>)
    }
    return clientList;
  }
  contentOption(i) {
    var retOption = [];
    if(i==="notif_cath") {
      if(this.state.cath_list.length > 0) {
          for(var u in this.state.cath_list) {
            retOption.push(<option value={this.state.cath_list[u]} key={u}>{this.state.cath_list[u]}</option>)
          }
      }
    }
    return retOption;
  }
  render() {
   
   return (
    <div className="main-container">
      <div  className="header-main"><IHeader/></div>
          <div className="flex-container">
              <div className="sidebar-main"><ISidemenu/></div>
              <div className="main-content">
                <div className="stTitle">Log Notification</div>
                <div className="stIndiTitle">List of log notification</div>
                <div className="mgT30">
                    {/*--*/}
                    <div className="content-container card card-body">
                        <div className="row show">
                            <div className="col-6 divMiddle">
                                <form method="post" id="search-form" className="form-inline">
                                    <div className="flex-container" >
                                        <select name="notif_type" className="form-control" 
                                            value={this.state.notif_type} 
                                            onChange={this.handleSelect}
                                            ref={(input) => this.textInputNotifPeriod = input}
                                        >
                                          <option value="1" key="1">1st Notification</option>
                                          <option value="2" key="2">2nd Notification</option>
                                          <option value="3" key="3">3rd Notification</option>
                                          <option value="4" key="4">4th Notification</option>
                                          
                                        </select>
                                        
                                    </div>
                                    <div className="mgL10">
                                      <select name="notif_cath" className="form-control" 
                                              value={this.state.notif_cath} 
                                              onChange={this.handleSelect}
                                              ref={(input) => this.textInputNotifCath = input}
                                          >
                                            <option value="" key="">All</option>
                                            {this.contentOption("notif_cath")}
                                          </select>
                                    </div>
                                </form>
                            </div>
                            <div className="col-6 form-inline justify-content-end">
                            </div>
                        </div>
                        <div className="row-field mgT20">
                            <table className={this.state.styleTb}>
                            <thead>
                                <tr key="0">
                                    <th scope="col">#</th>
                                    <th scope="col">Client Name</th>
                                    <th scope="col">Domain Name</th>
                                    <th scope="col">Licence Name</th>
                                    <th scope="col">Licence Category</th>
                                    <th scope="col">Expired Date</th>
                                    <th scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.contentTableList()}
                            </tbody>
                            </table>
                        </div>
                        <div className="row mt-3">
                            
                        </div>
                    </div>
                    <div>
                          {this.state.isOpen && <Popup
                            content={<><ISendNotifDetail/></>}
                            id={this.state.domainname} 
                            title={"Message"}
                            others={this.state.otherContent}
                            styles={"80%"}
                            handleClose={this.togglePopClose.bind(this, this.state.domainname)}
                          />}
                    </div>
                    {/*--*/}
                </div>
              </div>
          </div>
          <div id="loading-area" className="divHide loading"></div> 
    </div>
   );
 }
}
 
export default ISendNotification;